import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChart } from "../components/ComponentChart";
import { ContextReport1 } from "../Context";
import { REPORT_ID, REPORT_APE_ID } from '../constants';

export const report12ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_APE_ID === identification.reportId || REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart") {
      input.component = <ComponentChart context={componentContext as ContextReport1}></ComponentChart>;
    }
  }
  return next(input);
};
